import type { SpacingLevels } from '@lokalise/louis';

import fromTheme from './fromTheme';

type SpacingArgs =
    | [SpacingLevels]
    | [SpacingLevels, SpacingLevels]
    | [SpacingLevels, SpacingLevels, SpacingLevels]
    | [SpacingLevels, SpacingLevels, SpacingLevels, SpacingLevels];

const spacing = (...args: SpacingArgs) => fromTheme((theme) => args.map((level) => theme.space[level]).join(' '));

export default spacing;
